import React from 'react';
import {
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Alert,
  Input
} from 'reactstrap';
import { AvForm } from 'availity-reactstrap-validation';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';

const BatchImageFilterModal = ({
  filterError,
  modalOpenState,
  closeModalHandler,
  dateFilter,
  setDateFilter,
  batchOptions,
  selectedBatchOption,
  setBatchOption,
  isPublished,
  setIsPublished,
  applyFilters,
  resetFilters,
  exactDate,
  setExactDate,
}) => {
  function dateRangeHandler(setHook) {
    return function (dates) {
      const [start, end] = dates;
      setHook({
        startDate: start,
        endDate: end
      });
    };
  }

  function applyFilter() {
    closeModalHandler();
  }

  function clearFilter() {
    setDateFilter({
      startDate: null,
      endDate: null
    });
    setBatchOption(null);
    setIsPublished('');
  }

  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 100
    })
  };

  return (
    <React.Fragment>
      <Modal isOpen={modalOpenState} backdrop="static" size="md">
        <ModalHeader toggle={closeModalHandler}>Filter Batch Images</ModalHeader>
        <ModalBody>
          {filterError && (
            <Alert color="danger" role="alert">
              <i className="mdi mdi-block-helper mr-2"></i>
              {filterError}
            </Alert>
          )}
          <AvForm className="needs-validation">
            <Row>
              <Col md="12">
                <FormGroup>
                  <Label>Batch</Label>
                  <Select
                    options={batchOptions}
                    onChange={(selected) => setBatchOption(selected)}
                    value={selectedBatchOption}
                    styles={selectStyles}
                    isMulti={false}
                    placeholder="Select a batch..."
                  />
                </FormGroup>
              </Col>

              <Col md="12">
                <FormGroup>
                  <Label>Date</Label>
                  <DatePicker
                    selected={exactDate}
                    onChange={date => {
                      // Convert to UTC date at midnight
                      if (date) {
                        const utcDate = new Date(Date.UTC(
                          date.getFullYear(),
                          date.getMonth(),
                          date.getDate()
                        ));
                        setExactDate(utcDate);
                      } else {
                        setExactDate(null);
                      }
                    }}
                    className="form-control"
                    dateFormat="dd-MM-yyyy"
                    isClearable={true}
                    placeholderText="Select date"
                  />
                </FormGroup>
              </Col>
              
              {/* New Published Status Filter */}
              <Col md="12">
                <FormGroup>
                  <Label>Published Status</Label>
                  <Input
                    type="select"
                    value={isPublished}
                    onChange={(e) => setIsPublished(e.target.value)}
                  >
                    <option value="">All Statuses</option>
                    <option value="true">Published</option>
                    <option value="false">Unpublished</option>
                  </Input>
                </FormGroup>
              </Col>

            </Row>

            <ModalFooter>
              <Button size="sm" color="primary" onClick={applyFilters}>
                Apply Filter
              </Button>
              <Button size="sm" color="success" onClick={resetFilters}>
                Reset
              </Button>
              <Button size="sm" color="light" onClick={closeModalHandler}>
                Close
              </Button>
            </ModalFooter>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(BatchImageFilterModal);